// extracted by mini-css-extract-plugin
export default {"fieldTitle":"fieldTitle__RIzSh","mobileFieldTitle":"mobileFieldTitle__TaBBz"};